import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Fitter } from '@sc/data-access-models';
import { FittersSandboxService } from '@sc/data-access-state-management';
import { TabTitleStrategyService } from '@sc/data-access-translation';
import { MobileFitterOpeningsPageComponent } from '@sc/feature-fitter-page';
import { FeatureFlippingManagerService } from '@sc/feature-flipping';
import { ScreenUtils } from '@sc/utils';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sc-insurer-mobile-fitter-openings-page',
  styleUrls: ['./insurer-mobile-fitter-openings-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MobileFitterOpeningsPageComponent],
  template: `
    <div class="container">
      <sc-mobile-fitter-openings-page
        [fitter]="fitter"
        [itineraryDistanceInMeters]="itineraryDistanceInMeters"
        [itineraryDurationInSeconds]="itineraryDurationInSeconds"
      ></sc-mobile-fitter-openings-page>
    </div>
  `,
})
export class InsurerMobileFitterOpeningsPageComponent implements OnInit {
  private fitterId?: string;
  private brandId?: string;

  fitter?: Fitter;
  itineraryDistanceInMeters: number;
  itineraryDurationInSeconds: number;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly fitterSB: FittersSandboxService,
    public featureFlippingService: FeatureFlippingManagerService,
    private readonly changeRef: ChangeDetectorRef,
    private readonly tabTitleService: TabTitleStrategyService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.fitterId = params?.fitterId;
      this.brandId = params?.brandId;

      if (this.fitterId) {
        this.fitterSB
          .fetchFitter({ id: this.fitterId, brandId: this.brandId })
          .pipe(take(1))
          .subscribe((fitter) => this.fitterSB.addFitters([fitter]));
      }
    });

    this.route.queryParams.subscribe((query) => {
      this.itineraryDistanceInMeters = query?.meters;
      this.itineraryDurationInSeconds = query?.seconds;
    });

    this.fitterSB.fitters$.subscribe((fitters) => {
      this.fitter =
        fitters.find(
          (f) => f.id === this.fitterId && f.brandId === this.brandId
        ) ?? this.fitter;

      this.tabTitleService.setPagination({
        key: 'GlobalApplicativeConstants.tabTitles.paginations.fitterName',
        params: { fitterName: `${this.fitter?.brand} - ${this.fitter?.city}` },
      });

      this.changeRef.detectChanges();
    });
  }

  @HostListener('window:resize', ['$event'])
  closeOnResize() {
    if (!ScreenUtils.isMobileResolution()) {
      this.router.navigate([
        this.fitterId
          ? `/declaration/fitter/${this.brandId}/${this.fitterId}`
          : '/declaration/sinister-data',
      ]);
    }
  }
}
